import { GraphQLClient } from "graphql-request"
import { getSdk } from "../generated/api"

export const graphqlClient = new GraphQLClient(
  "https://uniform-object.myshopify.com/api/2021-04/graphql.json",
  {
    headers: {
      "X-Shopify-Storefront-Access-Token": "4da99563da34d0ee6c08f2a3287ca4dd",
    },
  }
)

export const shopifySdk = getSdk(graphqlClient)
